import {ClientMypageState} from "../store/client_mypage_state";
import {Reducer} from "redux";
import {
    ClientMypageAction,
    ClientMypageActionType,
    ICallbackGetMeClientAction,
    ICallbackUpdateClientAction,
    ICallbackUpdateCompanyAction,
} from "../action/client_mypage_action";

const initialState: ClientMypageState = {
    client: null,
    company: null,
    isLoading: false,
};

const clientMypageReducer: Reducer<ClientMypageState> = (state = initialState, action: ClientMypageAction): ClientMypageState => {
    switch (action.type) {

        case ClientMypageActionType.REQUEST_GET_ME_CLIENT: {
            return Object.assign({}, state, {
                client: state.client,
                company: state.company,
                isLoading: true,
            });
        }
        case ClientMypageActionType.CALLBACK_GET_ME_CLIENT: {
            const _action = action as ICallbackGetMeClientAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    client: _action.item ? _action.item.client : null,
                    company: _action.item ? _action.item.company : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    client: state.client,
                    company: state.company,
                    isLoading: false,
                });
            }
        }

        case ClientMypageActionType.REQUEST_UPDATE_COMPANY: {
            return Object.assign({}, state, {
                client: state.client,
                company: state.company,
                isLoading: true,
            });
        }
        case ClientMypageActionType.CALLBACK_UPDATE_COMPANY: {
            const _action = action as ICallbackUpdateCompanyAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    client: state.client,
                    company: _action.item ? _action.item.company : null,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    client: state.client,
                    company: state.company,
                    isLoading: false,
                });
            }
        }

        case ClientMypageActionType.REQUEST_UPDATE_CLIENT: {
            return Object.assign({}, state, {
                client: state.client,
                company: state.company,
                isLoading: true,
            });
        }
        case ClientMypageActionType.CALLBACK_UPDATE_CLIENT: {
            const _action = action as ICallbackUpdateClientAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    client: _action.item ? _action.item.client : null,
                    company: state.company,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    client: state.client,
                    company: state.company,
                    isLoading: false,
                });
            }
        }

        case ClientMypageActionType.REQUEST_UPDATE_PASSWORD: {
            return Object.assign({}, state, {
                client: state.client,
                company: state.company,
                isLoading: true,
            });
        }
        case ClientMypageActionType.CALLBACK_UPDATE_PASSWORD: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    client: state.client,
                    company: state.company,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    client: state.client,
                    company: state.company,
                    isLoading: false,
                });
            }
        }

        case ClientMypageActionType.REQUEST_UPDATE_EMAIL: {
            return Object.assign({}, state, {
                client: state.client,
                company: state.company,
                isLoading: true,
            });
        }
        case ClientMypageActionType.CALLBACK_UPDATE_EMAIL: {
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    client: state.client,
                    company: state.company,
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    client: state.client,
                    company: state.company,
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientMypageReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_mypage_reducer.ts